import { render, staticRenderFns } from "./SendTestDialog.vue?vue&type=template&id=c6a0272a"
import script from "./SendTestDialog.vue?vue&type=script&lang=js"
export * from "./SendTestDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports